module.exports = __webpack_public_path__ + "img/Discontent.e45092cf.png";